import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  CategoriaStakeholderIRO,
  DoppiaMaterialitaService,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-assegna-categoria-iro',
  standalone: false,

  templateUrl: './dialog-assegna-categoria-iro.component.html',
  styleUrl: './dialog-assegna-categoria-iro.component.scss',
})
export class DialogAssegnaCategoriaIroComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public categoriaSHEsterni: CategoriaStakeholderIRO[] = [];
  public categoriaSHInterni: CategoriaStakeholderIRO[] = [];

  constructor(
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,
    private readonly utilityService: UtilityService,
    public dialogRef: MatDialogRef<DialogAssegnaCategoriaIroComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      idDoppiaMaterialita: string;
      idAmbito: string;
      idTematica: string;
      idTema: string | null;
      idIro: string;
      iroType: string;
      disabled?: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    this._getCategorieSHperIRO();
  }

  private _getCategorieSHperIRO() {
    this.spinnerOver.show();

    this.doppiaMaterialitaService
      .getCategorieSHperIRO(this.data.idDoppiaMaterialita, this.data.idIro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (categorieSH) => {
          this.categoriaSHEsterni = categorieSH['ESTERNI'];
          this.categoriaSHInterni = categorieSH['INTERNI'];
        },
        error: (error) => {
          console.error(error);
        },
      });
  }

  salva() {
    let idCategorieSelezionate: string[] = [];

    this.categoriaSHInterni.forEach((categoriaSH) => {
      if (categoriaSH.selected) {
        idCategorieSelezionate.push(categoriaSH.id);
      }
    });

    this.categoriaSHEsterni.forEach((categoriaSH) => {
      if (categoriaSH.selected) {
        idCategorieSelezionate.push(categoriaSH.id);
      }
    });

    //Controllo che sia stato selezionato almeno una categoria
    if (!idCategorieSelezionate.length) {
      this.utilityService.openSnackBar('Selezionare almeno una categoria StakeHolder', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
      return;
    }

    this.spinnerOver.show();

    const objSalvataggio = {
      idDoppiaMaterialita: this.data.idDoppiaMaterialita,
      idAmbito: this.data.idAmbito,
      idTematica: this.data.idTematica,
      idTema: this.data.idTema,
      idIro: this.data.idIro,
      iroType: this.data.iroType,
      idCategorieSelezionate: idCategorieSelezionate,
    };

    this.doppiaMaterialitaService
      .putCategorieSHperIRO(objSalvataggio)
      .pipe(
        finalize(() => {
          this.spinnerOver.hide();
        }),
      )
      .subscribe({
        next: (response) => {
          this.dialogRef.close(!!idCategorieSelezionate.length);
        },
        error: (error) => {
          console.error(error);

          this.dialogRef.close(false);
        },
      });
  }
}
